export default {
  errorsRootKey: 'invoice/getTiers',
  resource: 'invoice/getTiers',
  actions: ['index']
}
